<template>
  <section v-if="!rerender" style="height: 800px;" class="w-100">
    <v-skeleton-loader
      v-if="loading"
      class="file-preview-loader"
      type="image"
    />
    <article v-else-if="!fileData">
      <EmptyStateBlock
        icon="mdi-file"
        :title="emptyStateTitle || $t('error.noFilesAvailableEmptyStateTitle')"
        :description="emptyStateDescription"
        border
      />
    </article>
    <article v-else class="h-100 w-100">
      <v-img
        v-if="isAnImage"
        contain
        :src="fileData"
        class="h-100"
        max-width="800px"
      />
      <object v-else :data="fileData" :type="fileType" class="h-100 w-100">
        <embed :src="fileData" :type="fileType" />
      </object>
    </article>
  </section>
</template>

<script>
import baseMixin from '@/mixins/baseMixin'
import { getType } from 'mime'
import EmptyStateBlock from '@components/general/empty-state-block.vue'

export default {
  name: 'FilePreviewContainer',
  components: {
    EmptyStateBlock,
  },
  mixins: [baseMixin],
  props: {
    fileData: {
      type: String,
      required: true,
    },
    fileDefinition: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
    },
    emptyStateTitle: {
      type: String,
      default: '',
    },
    emptyStateDescription: {
      type: String,
      default: '',
    },
  },
  data: () => {
    return {
      rerender: false,
    }
  },
  computed: {
    fileType() {
      try {
        return getType(this.fileDefinition?.fileName)
      } catch {
        return null
      }
    },
    isAnImage() {
      const type = this.fileType
      if (!type) return false
      return type.includes('image')
    },
  },
  watch: {
    fileData: {
      async handler() {
        this.rerender = true
        await this.$nextTick()
        this.rerender = false
      },
    },
  },
}
</script>

<style lang="scss">
.file-preview-loader .v-skeleton-loader__image {
  height: 100%;
}
</style>
